const userReviewsQuery = require('./userReviews');
const recentReviewsQuery = require('./recentReviews');
const createReviewQuery = require('./createReview');
const updateReviewQuery = require('./updateReview');
const deleteReviewQuery = require('./deleteReview');
const addReviewAssetQuery = require('./addReviewAsset');
const removeReviewAssetQuery = require('./removeReviewAsset');
const reviewListingAggregatesQuery = require('./reviewListingAggregates');
const reviewAggregatesQuery = require('./reviewAggregates');
const reviewAssetsQuery = require('./reviewAssets');

module.exports = {
  userReviewsQuery,
  recentReviewsQuery,
  createReviewQuery,
  updateReviewQuery,
  deleteReviewQuery,
  addReviewAssetQuery,
  removeReviewAssetQuery,
  reviewListingAggregatesQuery,
  reviewAggregatesQuery,
  reviewAssetsQuery,
};
